<template lang='pug'>
  include /mixins
  div#content-parent
    #content-view
    infinite-template-results-collector(
      :pagination="pagination",
      :items="items",
      :is-new-page="true"
    )
      template(#ssr="{ isSSR }")
        template(v-if="isSSR")
          slot
      template(#default="{ items }")
        template(v-if="items")
          +b.g-row.--align_stretch.--appearance_spaced
            template(v-for='item in items')
              +b.g-row.--align_stretch.--appearance_spaced
                template(v-for='object in item.value')
                  +b.g-cell.g-cols--12.--6-md.--4-xl.--3-fhd
                    cart-package(
                      :product='object'
                    )
                      //- @updatePrice="checkPrice"
    //- +b.ds-panel--space_3xl.UI-LIMIT-PAGINATION(
    //-   :pagination='pagination'
    //-   :need-load-more-btn='true'
    //-   @input='handlePaginate'
    //-   @load-more="handleLoadMore",
    //- )
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CartPackage from '@app/Cart/Variants/Package'

export default {
  props: ['loading', 'items', 'pagination'],
  data() {
    return {
      isInfinityTemplate: true,
    }
  },
  components: {
    CartPackage,
  },
  computed: {
    back() {
      if (this.items) {} // eslint-disable-line no-empty
      return `${window.location.pathname}${window.location.search}`
    },
  },
  methods: {
    scroll() {
      const el = document.getElementById('content-view')
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    },
    handleLoadMore() {
      const offset = this.pagination.offset + this.pagination.limit;
      this.handlePaginate({ offset }, true);
    },
    handlePaginate({ offset }, isLoadMore = false) {
      if (this.loading) {
        return
      }
      const init = 0
      const { limit = init } = this.pagination
      // this.$emit('update:pagination', { limit, offset })
      // this.scroll()
      this.isInfinityTemplate = isLoadMore;
      if (!isLoadMore) {
        this.$nextTick(() => {
          this.startPage = Math.floor(offset / limit) + 1;
        });
        this.scroll();
      }
      this.$emit('update:pagination', { limit, offset, page: Math.floor(offset / limit) + 1, infinite: isLoadMore });
    },
  },
}

</script>
